<template>
  <v-card class="mx-auto">
    <v-toolbar color="green darken-1" height="50" dark>
      <v-icon>mdi-package-variant-closed</v-icon>

      <v-toolbar-title class="text-body-1 ml-3">{{ $t("ORDERS.DASHBOARD.NEW_ORDERS.TITLE") }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon>
        <v-icon>mdi-magnify</v-icon>
      </v-btn>

      <v-btn color="transparent" depressed class="text-capitalize">
        <v-icon left size="22">mdi-checkbox-marked-circle</v-icon>
        {{ $t("ORDERS.DASHBOARD.NEW_ORDERS.APPROVE_BTN") }}
      </v-btn>
    </v-toolbar>

    <v-list two-line>
      <v-list-item-group v-model="selected" active-class="blue--text" multiple>
        <template v-for="(item, index) in yeniSiparisler">
          <v-list-item :key="item.title">
            <template v-slot:default="{ active }">
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>

                <v-list-item-subtitle class="text--primary grey--text text--darken-2" v-text="item.headline"></v-list-item-subtitle>

                <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-icon class="px-5 d-flex align-center">
                <v-list-item-subtitle class="">
                  {{ $t("ORDERS.DASHBOARD.NEW_ORDERS.AMOUNT") }}:
                  <strong>{{ $t("ORDERS.DASHBOARD.NEW_ORDERS.PRICE_FORMAT", { QUANTITY: 250 }) }}</strong>
                </v-list-item-subtitle>
              </v-list-item-icon>

              <v-list-item-action>
                <v-btn small depressed color="green darken-1" dark class="text-capitalize" :class="[active ? '' : '']">
                  <v-icon left>mdi-magnify</v-icon>
                  {{ $t("ORDERS.DASHBOARD.NEW_ORDERS.REVIEW_BTN") }}
                </v-btn>

                <!-- <v-icon v-if="!active" color="grey lighten-1">mdi-star-outline</v-icon>

                <v-icon v-else color="yellow darken-3">mdi-star</v-icon>-->
              </v-list-item-action>
            </template>
          </v-list-item>
          <v-divider v-if="index < yeniSiparisler.length - 1" :key="index"></v-divider>
        </template>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
function generateSupportRequests(languageCode) {
  const trHeadlines = [
    "Ürün teslimatı gecikti",
    "Ürün kalitesi hakkında soru",
    "İade talebi",
    "Destek hattı ile iletişim kuramıyorum",
    "Ürün montajında yardıma ihtiyacım var",
    "Garanti süresi uzatma talebi"
  ];

  const enHeadlines = [
    "Product delivery delayed",
    "Question about product quality",
    "Return request",
    "Unable to reach support line",
    "Need assistance with product assembly",
    "Request to extend warranty period"
  ];

  const trNames = ["Gökhan Korul", "Ömer Duran", "Ramazan Koç", "Tahir Aslan", "Mehmet Şahin"];

  const enNames = ["John", "Michael", "David", "Daniel", "James"];

  const headlines = languageCode === "tr-TR" ? trHeadlines : enHeadlines;
  const names = languageCode === "tr-TR" ? trNames : enNames;

  const supportRequests = [];

  for (let i = 0; i < headlines.length; i++) {
    const request = {
      action: "15 min",
      headline: headlines[i],
      subtitle: "",
      title: names[i]
    };
    supportRequests.push(request);
  }

  return supportRequests;
}

export default {
  name: "NewOrders",

  data() {
    return {
      selected: [],
      yeniSiparisler: []
    };
  },

  created() {
    this.yeniSiparisler = generateSupportRequests(this.$store.state.Language.apiLanguage)
  }
};
</script>

<style scoped></style>